import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Box from '../../Box';

import Option from './Option';

class ClickSort extends Component {
  constructor(props) {
    super(props);
    const { options } = props;
    this.flavoredOptions = options.map((opt, value) => ({
      ...opt,
      value,
    }));
    const { value } = props;
    this.state = {
      sorted: value || []
    }
  }

  handleOnChange = () => {
    const { sorted } = this.state;
    const { onChange, name } = this.props;
    if (onChange) {
      onChange({
        target: {
          value: sorted,
          name,
        },
        persist: () => {},
      });
    }
  }

  handleAdd = (value) => () => {
    const { sorted } = this.state;
    this.setState({
      sorted: sorted.concat(value),
    }, this.handleOnChange);
  }

  handleCancel = (index) => () => {
    const { sorted } = this.state;
    sorted.splice(index, 1);
    this.setState({
      sorted,
    }, this.handleOnChange);
  }

  render() {
    const {
      label,
      options,
      randomID,
      field,
      form,
      required,
      name,
      onChange,
      onBlur,
      value,
      values,
      readOnly,
      disabled,
      ...props
    } = this.props;
    const { sorted } = this.state;
    let inBoxOptions = sorted.map((value, index) => (
      <Option
        key={value}
        value={value}
        index={index}
        inBox
        onCancel={!readOnly && this.handleCancel(index)}
        {...options[value]}
      />
    ));
    return (
      <Box px="0.5em" my="1em" {...props}>
        {inBoxOptions}
        {!readOnly && this.flavoredOptions.filter((opt) => !sorted.includes(opt.value)).map((opt) => (
          <Option
            key={opt.value}
            value={opt.value}
            onClick={!readOnly && this.handleAdd(opt.value)}
            {...opt}
          />
        ))}
      </Box>
    );
  }
}

ClickSort.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
  })).isRequired,
};

export default ClickSort
